export const frontmatter = {
    "draft": false,
    "title": "Widgets",
    "sidebar_group": "referencia",
    "sidebar_label": "Widgets",
    "sidebar_order": 5
}

export const toc = []